import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Pages/Login';
import Dashboard from './components/Pages/Dashboard';
import Map from './components/Pages/Map';
import Alarms from './components/Pages/Alarms';
import Alarm from './components/Pages/Alarm';
import PotAlarms from './components/Pages/PotAlarms';
import VSAnalytics from './components/Pages/VS_Analytics';
import PotAnalytics from './components/Pages/Pot_Analytics';
import VacuumLevel from './components/Pages/Vacuum_Level';
import VacuumLevelTwo from './components/Pages/Vacuum_Level_Two';
import ForgotPassword from './components/Pages/ForgotPassword';
import SignUp from './components/Pages/SignUp'
import Devices from './components/Pages/Devices';
import PotOverview from './components/Pages/PotOverview';
import MapOverview from './components/Pages/MapOverview';
import User from './components/Pages/User';
import IssuesRedirect from './components/Pages/issues';
import MasterDashboard from './components/Pages/MasterDashboard';
import RemoteAccess2DP2VP from './components/Pages/RemoteAccess2DP2VP.js';
import RemoteAccessReset from './components/Pages/RemoteAccessReset.js';
import { LogoTitleProvider } from './components/classes/LogoTitleContext';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const loggedInStatus = sessionStorage.getItem('isLoggedIn');
    return loggedInStatus ? JSON.parse(loggedInStatus) : false;
  });

  const [userData, setUserData] = useState(() => {
    const storedUserData = sessionStorage.getItem('userData');
    return storedUserData ? JSON.parse(storedUserData) : {};
  });

  const [lastActivityTime, setLastActivityTime] = useState(new Date());

  const idleTimeout = 300000; // 5 minutes

  useEffect(() => {
    const updateActivityTime = () => setLastActivityTime(new Date());
    window.addEventListener('mousemove', updateActivityTime);
    window.addEventListener('keydown', updateActivityTime);

    const idleTimer = setInterval(() => {
      const currentTime = new Date();
      const timeDiff = currentTime - lastActivityTime;

      if (timeDiff > idleTimeout && isLoggedIn) {
        handleLogout();
        return <Navigate to="/" />;
      }
    }, 1000);

    return () => {
      window.removeEventListener('mousemove', updateActivityTime);
      window.removeEventListener('keydown', updateActivityTime);
      clearInterval(idleTimer);
    };
  }, [lastActivityTime, isLoggedIn]);

  useEffect(() => {
    if (userData && Object.keys(userData).length > 0) {
      //console.log('User Data:', userData);
    }
  }, [userData]);

  useEffect(() => {
    //console.log('isLoggedIn:', isLoggedIn);
  }, [isLoggedIn]);

  const handleLogin = async (email, password) => {
    try {
      const response = await fetch('https://restvacapi.aplus-technology.com/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),  // Send email instead of username
      });

      const data = await response.json();

      if (data.success) {
        const fetchedUserData = data.user;

        setIsLoggedIn(true);
        sessionStorage.setItem('isLoggedIn', true);

        setUserData(fetchedUserData);
        sessionStorage.setItem('userData', JSON.stringify(fetchedUserData));

        //console.log('Login Successful. User Data:', fetchedUserData);
        return true; // Indicate success
      } else {
        alert(data.message);
        return false; // Indicate failure
      }
    } catch (error) {
      alert('An error occurred during login. Please try again.');
      console.error('Login error:', error);
      return false; // Indicate failure
    }
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    sessionStorage.removeItem('isLoggedIn');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('username');
    sessionStorage.removeItem('password');
    sessionStorage.removeItem('loggedInUser');
    // You can also clear localStorage if data exists there
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('loggedInUser');
    setUserData({});
  };

  return (
    <div className="App">
      <LogoTitleProvider>
        <Router>
          <Routes>
            <Route path="/Login" element={isLoggedIn ? <Dashboard onLogout={handleLogout} userData={userData} loggedInUser={userData} /> : <Login onLogin={handleLogin} />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/SignUp" element={<SignUp />} />
            <Route path="/dashboard" element={isLoggedIn ? <Dashboard onLogout={handleLogout} userData={userData} loggedInUser={userData} /> : <Navigate to="/Login" />} />
            <Route path="/Map" element={isLoggedIn ? <Map userData={userData} loggedInUser={userData} /> : <Navigate to="/Login" />} />
            <Route path="/alarm" element={isLoggedIn ? <Alarm userData={userData} loggedInUser={userData} /> : <Navigate to="/Login" />} />
            <Route path="/alarms" element={isLoggedIn ? <Alarms userData={userData} loggedInUser={userData} /> : <Navigate to="/Login" />} />
            <Route path="/PotAlarms" element={isLoggedIn ? <PotAlarms userData={userData} loggedInUser={userData} /> : <Navigate to="/Login" />} />
            <Route path="/VSAnalytics" element={isLoggedIn ? <VSAnalytics userData={userData} loggedInUser={userData} /> : <Navigate to="/Login" />} />
            <Route path="/PotAnalytics" element={isLoggedIn ? <PotAnalytics userData={userData} loggedInUser={userData} /> : <Navigate to="/Login" />} />
            <Route path="/VacuumLevel" element={isLoggedIn ? <VacuumLevel userData={userData} loggedInUser={userData} /> : <Navigate to="/Login" />} />
            <Route path="/VacuumLevelTwo" element={isLoggedIn ? <VacuumLevelTwo userData={userData} loggedInUser={userData} /> : <Navigate to="/Login" />} />
            <Route path="/devices" element={isLoggedIn ? <Devices userData={userData} loggedInUser={userData} /> : <Navigate to="/Login" />} />
            <Route path="/RemoteAccess2DP2VP" element={isLoggedIn ? <RemoteAccess2DP2VP onLogout={handleLogout} userData={userData} loggedInUser={userData} /> : <Navigate to="/Login" />} />
            <Route path="/RemoteAccessReset" element={isLoggedIn ? <RemoteAccessReset onLogout={handleLogout} userData={userData} loggedInUser={userData} /> : <Navigate to="/Login" />} />
            <Route
              path="/PotOverview/:chamberNumber"
              element={isLoggedIn ? <PotOverview userData={userData} loggedInUser={userData} /> : <Navigate to="/Login" />}
            />
            <Route
              path="/MapOverview/:chamberNumber"
              element={isLoggedIn ? <MapOverview userData={userData} loggedInUser={userData} /> : <Navigate to="/Login" />}
            />
            <Route path="/user" element={isLoggedIn ? <User userData={userData} onLogout={handleLogout} loggedInUser={userData} /> : <Navigate to="/Login" />} />
            <Route path="/MasterDashboard" element={isLoggedIn ? <MasterDashboard userData={userData} onLogout={handleLogout} loggedInUser={userData} /> : <Navigate to="/Login" />} />
            <Route path="/issues" element={<IssuesRedirect />} />
          </Routes>
        </Router>
      </LogoTitleProvider>
    </div>
  );
}

export default App;
